/* eslint-disable import/prefer-default-export */
export const MARKETPLACE_STATUS_UPDATE = 'MARKETPLACE_STATUS_UPDATE';
